// Code-splitting helper for module page overrides and tabs (routes use TanStack's lazyRouteComponent instead).
//   entityOverrides: { control: { ListPage: lazyComponent(() => import('./ControlsListPage'), 'ControlsListPage') } }
import { type ComponentType, lazy, Suspense } from 'react'
import { PageSkeleton } from '../components/states'

export function lazyComponent<P extends object, K extends string>(
  load: () => Promise<Record<K, ComponentType<P>>>,
  exportName: K,
): ComponentType<P> {
  // Typed loosely inside; the public signature keeps the caller's props type.
  const Lazy = lazy<ComponentType<Record<string, unknown>>>(async () => ({
    default: (await load())[exportName] as unknown as ComponentType<Record<string, unknown>>,
  }))
  function LazyComponent(props: P) {
    return (
      <Suspense fallback={<PageSkeleton />}>
        <Lazy {...(props as Record<string, unknown>)} />
      </Suspense>
    )
  }
  LazyComponent.displayName = `Lazy(${exportName})`
  return LazyComponent
}
